import { UserResponse } from "@/services/types/types";

export enum Roles {
  Admin = "Administrador",
  MRM = "MRM",
  Client = "Cliente",
}

export const getRoles = (userInfo: UserResponse) => {
  return [
    {
      value: "Administrador",
      label: "Administrador",
      visibleIfAdmin: userInfo?.role === "Administrador",
    },
    {
      value: "Cliente",
      label: "Cliente",
      visibleIfAdmin: true,
    },
    {
      value: "MRM",
      label: "MRM",
      visibleIfAdmin: userInfo?.role === "Administrador",
    },
  ];
};
